/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCycleDays } from 'app/entities/cycle-day/cycle-day.reducer';
import { BleedingLevel } from 'app/shared/model/enumerations/bleeding-level.model';
import { BleedingColor } from 'app/shared/model/enumerations/bleeding-color.model';
import { ClotType } from 'app/shared/model/enumerations/clot-type.model';
import { createEntity, getEntity, reset, updateEntity } from './bleeding.reducer';

export const BleedingUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const cycleDays = useAppSelector(state => state.cycleDay.entities);
  const bleedingEntity = useAppSelector(state => state.bleeding.entity);
  const loading = useAppSelector(state => state.bleeding.loading);
  const updating = useAppSelector(state => state.bleeding.updating);
  const updateSuccess = useAppSelector(state => state.bleeding.updateSuccess);
  const bleedingLevelValues = Object.keys(BleedingLevel);
  const bleedingColorValues = Object.keys(BleedingColor);
  const clotTypeValues = Object.keys(ClotType);

  const handleClose = () => {
    navigate(`/bleeding${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCycleDays({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.cntPadsChanged !== undefined && typeof values.cntPadsChanged !== 'number') {
      values.cntPadsChanged = Number(values.cntPadsChanged);
    }

    const entity = {
      ...bleedingEntity,
      ...values,
      cycleDay: cycleDays.find(it => it.id.toString() === values.cycleDay?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          level: 'SPOTTING',
          color: 'PINK',
          clots: 'SMALL',
          ...bleedingEntity,
          cycleDay: bleedingEntity?.cycleDay?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bleeding.home.createOrEditLabel" data-cy="BleedingCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bleeding.home.createOrEditLabel">Create or edit a Bleeding</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="bleeding-id"
                  label={translate('tinyMedicRestApp.bleeding.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.level')}
                id="bleeding-level"
                name="level"
                data-cy="level"
                type="select"
              >
                {bleedingLevelValues.map(bleedingLevel => (
                  <option value={bleedingLevel} key={bleedingLevel}>
                    {translate(`tinyMedicRestApp.BleedingLevel.${bleedingLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.color')}
                id="bleeding-color"
                name="color"
                data-cy="color"
                type="select"
              >
                {bleedingColorValues.map(bleedingColor => (
                  <option value={bleedingColor} key={bleedingColor}>
                    {translate(`tinyMedicRestApp.BleedingColor.${bleedingColor}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.clots')}
                id="bleeding-clots"
                name="clots"
                data-cy="clots"
                type="select"
              >
                {clotTypeValues.map(clotType => (
                  <option value={clotType} key={clotType}>
                    {translate(`tinyMedicRestApp.ClotType.${clotType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.comments')}
                id="bleeding-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.active')}
                id="bleeding-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.draft')}
                id="bleeding-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.cursor')}
                id="bleeding-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.lastUpdated')}
                id="bleeding-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.microSec')}
                id="bleeding-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.timestampEntry')}
                id="bleeding-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bleeding.cntPadsChanged')}
                id="bleeding-cntPadsChanged"
                name="cntPadsChanged"
                data-cy="cntPadsChanged"
                type="text"
              />
              <ValidatedField
                id="bleeding-cycleDay"
                name="cycleDay"
                data-cy="cycleDay"
                label={translate('tinyMedicRestApp.bleeding.cycleDay')}
                type="select"
              >
                <option value="" key="0" />
                {cycleDays
                  ? cycleDays.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/bleeding" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BleedingUpdate;
